import { Payee } from '@root/api/ump-catalog-manager'

export const filterPayeesForSearch = (payees: Payee[]) =>
  payees.filter((payee) => {
    if ((payee.features?.tsp_url as string)?.includes('appstore') && payee.features?.tsp_url !== 'appstore') {
      return false
    }

    return payee.features?.platform_type === 'business' || payee.features?.platform_type === 'cyber'
  })
